(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!window.santaRitaCollectionFiltersReady) {
    window.santaRitaCollectionFiltersReady = true;

    const parsePrice = (value) => {
      const normalized = String(value || '').replace(/[^\d.,]/g, '');
      const hasDot = normalized.includes('.');
      const hasComma = normalized.includes(',');
      let wholeValue = normalized;

      if (hasDot && hasComma) {
        wholeValue = normalized.replace(/\./g, '').split(',')[0] || '';
      } else if (hasDot) {
        wholeValue = normalized.replace(/\./g, '');
      } else if (hasComma) {
        const [beforeComma = '', afterComma = ''] = normalized.split(',');
        wholeValue = afterComma.length === 3 ? `${beforeComma}${afterComma}` : beforeComma;
      }

      return Number(wholeValue || 0);
    };

    const formatPrice = (value) => String(Math.round(Number(value || 0))).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    const getPriceStateFromParams = (params) => {
      const minValue = parsePrice(params.get('filter.v.price.gte') || 0);
      const maxValue = parsePrice(params.get('filter.v.price.lte') || 0);

      return minValue || maxValue ? { minValue, maxValue } : null;
    };

    const getPriceStateFromURL = () => getPriceStateFromParams(new URLSearchParams(window.location.search));

    const isMobileViewport = () => window.matchMedia('(max-width: 749px)').matches;

    const getCurrentAbsoluteMax = () =>
      Number(
        document.querySelector('[data-sr-price-slider]')?.dataset.srPriceMax ||
          window.santaRitaPriceRangeState?.absoluteMax ||
          0
      );

    const setupSlider = (slider, force = false) => {
      if (!slider || (slider.dataset.srPriceReady === 'true' && !force)) return;
      const facet = slider.closest('price-facet-component');
      const rangeStatus = facet?.closest('details')?.querySelector('[data-range-max]');
      const minInput = facet?.querySelector('[ref="minInput"]');
      const maxInput = facet?.querySelector('[ref="maxInput"]');
      const minRange = slider.querySelector('[data-sr-price-range="min"]');
      const maxRange = slider.querySelector('[data-sr-price-range="max"]');

      if (!facet || !minInput || !maxInput || !minRange || !maxRange) return;

      const maxValue = Math.max(
        1,
        parsePrice(rangeStatus?.dataset.rangeMax || maxInput.dataset.max || maxInput.placeholder || maxInput.value || 100)
      );
      const urlState = getPriceStateFromURL();
      const savedState = window.santaRitaPriceRangeState;
      const hasSavedState = savedState && Number(savedState.absoluteMax) === maxValue;
      const minValue = hasSavedState ? Number(savedState.minValue) : parsePrice(urlState?.minValue || minInput.value || 0);
      const currentMax = hasSavedState
        ? Number(savedState.maxValue)
        : parsePrice(urlState?.maxValue || maxInput.value || maxInput.placeholder || maxValue);
      const resolvedMax = currentMax || maxValue;

      slider.dataset.srPriceReady = 'true';
      slider.dataset.srPriceMax = String(maxValue);
      minRange.max = String(maxValue);
      maxRange.max = String(maxValue);
      minRange.value = String(Math.min(minValue, maxValue));
      maxRange.value = String(Math.min(resolvedMax, maxValue));
      slider.style.setProperty('--sr-price-min', `${(Number(minRange.value) / maxValue) * 100}%`);
      slider.style.setProperty('--sr-price-max', `${(Number(maxRange.value) / maxValue) * 100}%`);
    };

    const applyFilterState = () => {
      document.querySelectorAll('[data-santa-rita-collection]').forEach((container) => {
        const shouldOpen = window.santaRitaCollectionFiltersOpen === true;
        const toggle = container.querySelector('[data-sr-filter-toggle]');

        container.classList.toggle('santa-rita-filters-open', shouldOpen);
        toggle?.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        container.querySelectorAll('[data-sr-price-slider]').forEach((slider) => setupSlider(slider, true));
      });
    };

    const syncSlider = (range) => {
      const slider = range.closest('[data-sr-price-slider]');
      setupSlider(slider);

      const facet = range.closest('price-facet-component');
      const minInput = facet?.querySelector('[ref="minInput"]');
      const maxInput = facet?.querySelector('[ref="maxInput"]');
      const minRange = slider?.querySelector('[data-sr-price-range="min"]');
      const maxRange = slider?.querySelector('[data-sr-price-range="max"]');

      if (!slider || !minInput || !maxInput || !minRange || !maxRange) return;

      let minValue = Number(minRange.value);
      let maxValue = Number(maxRange.value);

      if (minValue > maxValue) {
        if (range === minRange) {
          maxValue = minValue;
          maxRange.value = String(maxValue);
        } else {
          minValue = maxValue;
          minRange.value = String(minValue);
        }
      }

      minInput.value = minValue > 0 ? formatPrice(minValue) : '';
      maxInput.value = maxValue < Number(slider.dataset.srPriceMax) ? formatPrice(maxValue) : '';

      const absoluteMax = Number(slider.dataset.srPriceMax || 1);
      slider.style.setProperty('--sr-price-min', `${(minValue / absoluteMax) * 100}%`);
      slider.style.setProperty('--sr-price-max', `${(maxValue / absoluteMax) * 100}%`);

      window.santaRitaPriceRangeState = {
        minValue,
        maxValue,
        absoluteMax,
      };
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const toggle = target?.closest('[data-sr-filter-toggle]');

      if (!toggle) return;

      const container = toggle.closest('[data-santa-rita-collection]');

      if (isMobileViewport()) {
        const drawer = document.getElementById('filters-drawer');

        if (drawer?.showDialog) {
          drawer.showDialog();
          toggle.setAttribute('aria-expanded', 'true');

          window.requestAnimationFrame(() => {
            drawer.querySelectorAll('[data-sr-price-slider]').forEach((slider) => setupSlider(slider, true));
          });

          return;
        }
      }

      container?.classList.add('santa-rita-filters-transitioning');
      const isOpen = container?.classList.toggle('santa-rita-filters-open');

      window.santaRitaCollectionFiltersOpen = isOpen;
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      container?.querySelectorAll('[data-sr-price-slider]').forEach((slider) => setupSlider(slider, true));

      window.setTimeout(() => {
        container?.classList.remove('santa-rita-filters-transitioning');
      }, 360);
    });

    document.addEventListener('input', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const range = target?.closest('[data-sr-price-range]');

      if (!range) return;

      syncSlider(range);
    });

    document.addEventListener('filter:update', (event) => {
      const openContainer = document.querySelector('[data-santa-rita-collection].santa-rita-filters-open');
      const queryParams = event?.detail?.queryParams;
      const priceState = queryParams instanceof URLSearchParams ? getPriceStateFromParams(queryParams) : getPriceStateFromURL();
      const absoluteMax = getCurrentAbsoluteMax();

      window.santaRitaCollectionFiltersOpen = openContainer != null;

      if (priceState && absoluteMax > 0) {
        window.santaRitaPriceRangeState = {
          minValue: Number(priceState.minValue || 0),
          maxValue: Number(priceState.maxValue || 0),
          absoluteMax,
        };
      } else if (!priceState) {
        window.santaRitaPriceRangeState = null;
      }
    });

    document.addEventListener(
      'change',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const range = target?.closest('[data-sr-price-range]');

        if (!range) return;

        event.stopPropagation();
        syncSlider(range);

        const facet = range.closest('price-facet-component');
        const minInput = facet?.querySelector('[ref="minInput"]');

        minInput?.dispatchEvent(new Event('change', { bubbles: true }));
      },
      true
    );

    document.addEventListener('DOMContentLoaded', () => {
      applyFilterState();

      document.getElementById('filters-drawer')?.addEventListener('dialog:close', () => {
        document.querySelectorAll('[data-sr-filter-toggle]').forEach((toggle) => {
          toggle.setAttribute('aria-expanded', 'false');
        });
      });
    });

    new MutationObserver(() => {
      window.requestAnimationFrame(applyFilterState);
    }).observe(document.body, { childList: true, subtree: true });

    const getNormalizedSectionId = (sectionId) => sectionId?.replace(/^shopify-section-/, '');

    const setLoadMoreState = (button, state) => {
      button.dataset.currentPage = String(state.currentPage);
      button.dataset.mode = state.currentPage >= state.lastPage ? 'collapse' : 'load';
      button.textContent = state.currentPage >= state.lastPage ? 'Mostrar menos' : 'Cargar más';
      button.disabled = false;
    };

    document.addEventListener('click', async (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('[data-sr-load-more]');

      if (!(button instanceof HTMLButtonElement)) return;

      const container = button.closest('[data-santa-rita-collection]');
      const grid = container?.querySelector('[ref="grid"]');

      if (!container || !grid) return;

      if (button.dataset.mode === 'collapse') {
        grid.querySelectorAll('[ref="cards[]"]').forEach((card) => {
          if (card instanceof HTMLElement && card.dataset.page !== '1') {
            card.remove();
          }
        });

        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        history.pushState('', '', url.toString());

        setLoadMoreState(button, {
          currentPage: 1,
          lastPage: Number(button.dataset.lastPage || 1),
        });

        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const currentPage = Number(button.dataset.currentPage || 1);
      const lastPage = Number(button.dataset.lastPage || 1);
      const nextPage = currentPage + 1;

      if (nextPage > lastPage) {
        setLoadMoreState(button, { currentPage: lastPage, lastPage });
        return;
      }

      button.disabled = true;
      button.textContent = 'Cargando...';

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(nextPage));
        url.searchParams.set('section_id', getNormalizedSectionId(container.getAttribute('section-id')));
        url.hash = '';

        const response = await fetch(url.toString());
        const sectionHTML = await response.text();
        const parsedSection = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const nextGrid = parsedSection.querySelector('[ref="grid"]');
        const nextCards = nextGrid?.querySelectorAll(':scope > [ref="cards[]"]');

        if (!nextCards || nextCards.length === 0) {
          setLoadMoreState(button, { currentPage: lastPage, lastPage });
          return;
        }

        grid.append(...nextCards);

        setLoadMoreState(button, { currentPage: nextPage, lastPage });
      } catch (error) {
        button.disabled = false;
        button.textContent = 'Cargar más';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
